import React from 'react'

class Intro extends React.Component {
  constructor(props) {
    super(props)
  }

  joinAsPlayer = () => {
    const url = `https://app.playvs.com/sign-up/player`
    window.open(url, '_blank')
  }

  joinAsCoach = () => {
    const url = `https://app.playvs.com/sign-up/coach`
    window.open(url, '_blank')
  }

  render() {
    return (
      <div className="intro intro--shortenMore">
        <div className="container">
            <div className="intro__content">
              <h1>
                About PlayVS
              </h1>
              <p>
                PlayVS is the official league for high school esports. We’re passionate about the future of sports — and we hope you are, too.
              </p>
            </div>
        </div>
        {/*<div className="intro__mask intro__mask--fadeToRight"></div>*/}
      </div>
    )
  }
}

export default Intro



// WEBPACK FOOTER //
// ./src/common/ui/components/IntroAbout.js